export default (editor, config = {}) => {
  const bm = editor.BlockManager;
  bm.add('video_mp4', {
    label: 'Player',
    category: 'Media',
    content: {
      activeOnRender: 1,
      resizable: {
        step: 0.2,
        minDim: 10,
        maxDim: 100,
        currentUnit: 1,
        autoHeight: true,
      },
      void: true,
      type: 'video_mp4',
      style: {
        width: '100%',
        height: '100%',
        top: '0% !important',
        left: '0% !important',
      },
    },
    attributes: {
      class: 'fa fa-play', //icon in the panel
    },
  });
};



// WEBPACK FOOTER //
// ./src/plugins/player-mp4/blocks.js